import { render, staticRenderFns } from "./NotificationAboutStartMatch.vue?vue&type=template&id=203121c2&scoped=true&"
import script from "./NotificationAboutStartMatch.vue?vue&type=script&lang=js&"
export * from "./NotificationAboutStartMatch.vue?vue&type=script&lang=js&"
import style0 from "./NotificationAboutStartMatch.vue?vue&type=style&index=0&id=203121c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203121c2",
  null
  
)

export default component.exports